/**
 * Enum for Auto Mail Status listed in the MailerMainPage
 */
export enum AutoMailStatus {
	Pending = "PENDING",
	Processing = "PROCESSING",
	Success = "SUCCESS",
	Error = "ERROR"
}
